import { useMemo } from 'react';
import { printAST, xml2ast, allHtmlParsers, htmlNodeToJsxPrinter, textNodeToJsxPrinter } from '@utils/ast';
import { freetextInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { container } from './readonly.richtext.style.js';
import { jsx } from 'react/jsx-runtime';

function RichtextReadonly(props) {
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => freetextInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.task.id])
  });
  const content = useMemo(() => printAST(xml2ast(inputEntry?.richtext ?? "", allHtmlParsers, "text/html"), {
    text: textNodeToJsxPrinter,
    html: htmlNodeToJsxPrinter
  }), [inputEntry?.richtext]);
  return /*#__PURE__*/jsx("div", {
    className: container,
    children: content
  });
}

export { RichtextReadonly };
//# sourceMappingURL=readonly.richtext.js.map
